import { SA_VIEW_FETCH_DATA_START, SA_VIEW_FETCH_DATA_ERROR, SA_VIEW_FETCH_DATA_SUCCESS } from '../actions/actiontypes';

export default function (state = {}, action) {
  switch (action.type) {
    case SA_VIEW_FETCH_DATA_START: {
      return {};
    }
    case SA_VIEW_FETCH_DATA_ERROR: {
      return { error: action.payload }
    }
    case SA_VIEW_FETCH_DATA_SUCCESS: {
      return { ...state, ...action.payload };
    }
    default:
      return state;
  }
}